import React from 'react'
import { Packages, VerifiedUser } from 'iconoir-react';

  
  const iconLookup = {
    "true": <Packages  />,
    "false": <VerifiedUser  />,
    
  };
  

export default function Typesol({tableMeta}) {
   
    let tipo = tableMeta.package;
    return (
      iconLookup[tipo] || null
    );
  
  }







